import React from 'react';
import PropTypes from 'prop-types';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';

function EventSurchargeList({ items, onDelete }) {
  return (
    <List sx={{ width: '100%' }}>
      <ListItem divider key="header" disableGutters>
        <ListItemText primary="Name" />
        <p style={{ marginRight: '5%' }}>Price</p>
      </ListItem>

      {items.map((i) => (
        <ListItem
          divider
          key={i.key}
          disableGutters
          secondaryAction={
            <IconButton edge="end" aria-label="delete" onClick={onDelete(i)}>
              <DeleteIcon />
            </IconButton>
          }>
          <ListItemText primary={i.name} />
          <p style={{ color: '#0997BA', fontWeight: 'bold' }}>${i.price}</p>
        </ListItem>
      ))}
    </List>
  );
}

EventSurchargeList.propTypes = {
  onDelete: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      size: PropTypes.string.isRequired,
      cost: PropTypes.string.isRequired,
    }).isRequired,
  ).isRequired,
};

export default EventSurchargeList;
